import { Box, styled } from '@mui/system';
import TranslationHelper from '@/app/helpers/TranslationHelper';
import FieldWrapper from '@/app/components/common/formikWrappers/FieldWrapper';
import { IconButton, MenuItem, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import React, { useEffect, useState } from 'react';
import { Field, FormikErrors } from 'formik';
import { restGetTemplates } from '@/app/services/reports';
import { IReportsType, IReportTemplate } from '@/app/state/ui/reportsSlice';
import { UserReportsFormValues } from '@/app/components/globalDialog/components/UserEditDialog/ReportsTab/types';

const StyledField = styled(Field)(({ theme }) => ({
    flex: 1,
    marginRight: `${theme.spacing(5)} !important`,
    width: 210,
    '& .MuiMenu-list': {
        display: 'block',
    },
}));

type Props = {
    assignmentId: number;
    reportTypeId?: number;
    onDelete: () => void;
    errors?: FormikErrors<UserReportsFormValues>;
    onReportTypeChange: (assignmentId: number) => void;
    reportTypes: IReportsType[] | null;
};

export const ReportDefinitionRow = ({
    assignmentId,
    reportTypeId,
    onDelete,
    errors,
    onReportTypeChange,
    reportTypes,
}: Props) => {
    const [templates, setTemplates] = useState<IReportTemplate[]>([]);

    useEffect(() => {
        if (reportTypeId !== undefined) {
            reloadTemplates(reportTypeId);
        }
    }, [reportTypeId]);

    const reloadTemplates = (typeId: number) => {
        restGetTemplates(typeId).then((res) => setTemplates(res));
    };

    return (
        <Box display="flex" flexDirection="row" height={80}>
            <Box display="flex" flex={1}>
                <StyledField
                    name={`reports.${assignmentId}.name`}
                    label={TranslationHelper.translate('Name')}
                    component={FieldWrapper}
                    required
                    error={Boolean(errors?.[assignmentId]?.name)}
                    helperText={errors?.[assignmentId]?.name}
                />
                <StyledField
                    name={`reports.${assignmentId}.typeId`}
                    label={TranslationHelper.translate('Type')}
                    select
                    component={FieldWrapper}
                    required
                    afterOnChange={(val: string) => {
                        onReportTypeChange(assignmentId);
                        reloadTemplates(Number(val));
                    }}
                    error={Boolean(errors?.[assignmentId]?.typeId)}
                    helperText={errors?.[assignmentId]?.typeId}
                >
                    {reportTypes ? (
                        reportTypes.map((value) => (
                            <MenuItem key={value.id} value={value.id}>
                                {value.name}
                            </MenuItem>
                        ))
                    ) : (
                        <MenuItem />
                    )}
                </StyledField>
                <StyledField
                    name={`reports.${assignmentId}.templateId`}
                    label={TranslationHelper.translate('Template')}
                    select
                    component={FieldWrapper}
                    required
                    error={Boolean(errors?.[assignmentId]?.templateId)}
                    helperText={errors?.[assignmentId]?.templateId}
                >
                    {templates ? (
                        templates.map((value) => (
                            <MenuItem key={value.id} value={value.id}>
                                {value.name}
                            </MenuItem>
                        ))
                    ) : (
                        <MenuItem />
                    )}
                </StyledField>
            </Box>
            <Box pt={2}>
                <Tooltip title={TranslationHelper.translate('Remove')}>
                    <IconButton onClick={onDelete}>
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            </Box>
        </Box>
    );
};
